import React from 'react'
import { Button } from '@mui/material';

export default function HelpdeskHistory() {
    return (
        <Button sx={{ height: "80px", width: "200px" }} variant="outlined">ประวัติการแจ้งซ่อม</Button>
    )
}
